import PencilIcon from "@mui/icons-material/CreateOutlined";
import { IconButton, IconButtonProps } from "@mui/material";

export const EditButton = (props: IconButtonProps) => (
  <IconButton sx={{ ml: 1 }} {...props}>
    <PencilIcon color={props.disabled ? "disabled" : "primary"} />
  </IconButton>
);
